var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-modal-table',{attrs:{"dictionary_link":"/languages","title":"Lista języków","numeral_text":['język', 'języki', 'języków'],"columns_title":['name', 'code', 'currency', 'default']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }